'use client';
import * as React from 'react';

const DefaultMenuIcon = React.memo(function DefaultMenuIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      style={{ width: '1em', height: '1em' }}
    >
      <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
    </svg>
  );
});

export default DefaultMenuIcon;
